import { flatten } from 'flat';

export function deepFlatten(
  target: Record<string, unknown>
): Record<string, unknown> {
  let flattenObj: Record<string, unknown> = flatten(target);

  Object.keys(flattenObj).forEach((key: string) => {
    try {
      const jsonValue: Record<string, unknown> = JSON.parse(
        flattenObj[key] as string
      );
      const valueObj: Record<string, unknown> = {};
      valueObj[key] = jsonValue;
      const flattedValue: Record<string, unknown> = flatten(valueObj);
      flattenObj = { ...flattenObj, ...flattedValue };
      flattenObj[key] = jsonValue;
    } catch (e) {
      return;
    }
  });

  return flattenObj;
}

export const stringifyWithCircularReference = (obj: any) => {
  let cache: any = [];
  const str: string = JSON.stringify(obj, function (key, value) {
    if (typeof value === 'object' && value !== null) {
      if (cache.indexOf(value) !== -1) {
        // Circular reference found, discard key
        return;
      }
      // Store value in our collection
      cache.push(value);
    }
    return value;
  });
  cache = null; // reset the cache
  return str;
};
